import React from 'react';

const MyPortfolio = () => {
    return (
        <div>
            <h2>Name: Mahbub -E- Khoda Sajon</h2>
            <p>
                Email: sajon.mahbub@gmail.com 
                <br />
                Educational Background: Northern University Bangladesh, Department of CSE. Final Year.
                <br />
                Skills: HTML 5, CSS 3, BOOTSTRAP, TAILWIND CSS, DAISY UI, REACT BOOTSTRAP, REACT JS, FIREBASE, GITHUB, NODE JS, MONGODB. 
                <br />
                Link 1:  https://plant-planet-def76.web.app/
                Link 2:  https://agro-advisor.web.app/
                Link 3:  https://lustrous-croissant-ddf26b.netlify.app/
            </p>
        </div>
    );
};

export default MyPortfolio;